import { render } from "./VerticalMode.vue?vue&type=template&id=35264260"
import script from "./VerticalMode.vue?vue&type=script&lang=ts"
export * from "./VerticalMode.vue?vue&type=script&lang=ts"
script.render = render

export default script